module.exports = __webpack_public_path__ + "media/images/stock_groups/e80c-507ef7f363d19e7b67d4df7b37c35400.svg";